import { Environment, User } from '../types';
import * as LogRocket from 'logrocket';
// required for hubspot tracker to play nice with typescript

declare global {
    interface Window {
        _hsq: HubSpotInterface;

        LogRocket: typeof LogRocket;
    }
}

interface HubSpotInterface {
    push(args: unknown[]): unknown;
}

interface HubspotUserProperties {
    email: string;
}

export const trackHubspotPageView: () => void = () => {
    if (process.env.NODE_ENV !== Environment.Production) {
        console.log(`Tracking hubspot pageview event for page: ${document.title}`);
    }

    const _hsq = (window._hsq = window._hsq || []);
    _hsq.push(['trackPageView']);
};

export const identify: (props: HubspotUserProperties) => void = (props) => {
    const _hsq = (window._hsq = window._hsq || []);

    _hsq.push(['identify', props]);
};

export const updatePath: (path: string) => void = (path) => {
    const _hsq = (window._hsq = window._hsq || []);

    _hsq.push(['setPath', path]);
};

export const userProperties: (user: User) => HubspotUserProperties = (user) => {
    return {
        email: user.email,
    };
};
